import makeRootReducer from "./reducers";

export { injectReducer, makeRootReducer } from "./reducers";
export default makeRootReducer;
